import { Dropdown } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const normalizeLng = (lng) => (lng || "en").split("-")[0].toLowerCase();

export const LANGUAGE_STORAGE_KEY = "econtent-admin-lng";

const LanguageSwitcher = () => {
    const { t, i18n } = useTranslation("common");
    const current = normalizeLng(i18n.language);

    const setLang = (lng) => {
        if (normalizeLng(lng) === current) return;

        try {
            localStorage.setItem(LANGUAGE_STORAGE_KEY, lng);
        } catch {
            /* private mode / quota */
        }

        window.location.reload();
    };

    return (
        <div className="pc-h-item">
            <Dropdown align="end" className="language-switcher">
                <Dropdown.Toggle
                    as="span"
                    className="pc-head-link ms-0 cursor-pointer d-inline-flex align-items-center"
                    aria-label={t("LanguageSwitcher.ariaLabel")}
                >
                    <span className="pc-head-link-label text-uppercase fw-medium user-select-none">
                        {current === "ua" ? "UA" : "EN"}
                    </span>
                </Dropdown.Toggle>
                <Dropdown.Menu className="dropdown-menu-end">
                    <Dropdown.Item active={current === "en"} onClick={() => setLang("en")}>
                        {t("LanguageSwitcher.english")}
                    </Dropdown.Item>
                    <Dropdown.Item active={current === "ua"} onClick={() => setLang("ua")}>
                        {t("LanguageSwitcher.ukrainian")}
                    </Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        </div>
    );
};

export default LanguageSwitcher;
